import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const deleteWrapper = style({
  display: "grid",
  gap: vars.space.m,
});

export const header = style({
  marginBottom: vars.space.xs,
  fontSize: vars.fontSizes.heading.m,
});
